import React from 'react';
import { cn } from '@/lib/utils';

export interface StyledLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

const StyledLabel = React.forwardRef<HTMLLabelElement, StyledLabelProps>(
  ({ className, required, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn('main-label', className)}
        {...props}
      >
        {children}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    );
  }
);

StyledLabel.displayName = 'StyledLabel';

export { StyledLabel };

